import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { TRANSLATIONS, LANGUAGES, RTL_LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "tr";
    const saved = window.localStorage.getItem("tacle_lang");
    if (saved && TRANSLATIONS[saved]) return saved;
    return "tr";
  });

  const changeLang = useCallback((code) => {
    if (!TRANSLATIONS[code]) return;
    setLang(code);
    try {
      window.localStorage.setItem("tacle_lang", code);
    } catch (error) {
      console.warn("tacle_lang: localStorage write failed", error);
    }
  }, []);

  useEffect(() => {
    const isRtl = RTL_LANGUAGES.includes(lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", isRtl ? "rtl" : "ltr");
    document.documentElement.classList.toggle("rtl", isRtl);
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang: changeLang,
      t: TRANSLATIONS[lang],
      isRtl: RTL_LANGUAGES.includes(lang),
      languages: LANGUAGES,
    }),
    [lang, changeLang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
